export const defaultLanguage = "fr";

export const languageDisplayFormats = [{ value: "en", label: "English" }, { value: "fr", label: "Français" }];



// WEBPACK FOOTER //
// ./src/helpers/Language/languageHelpers.js